import React from "react";
import styled from "styled-components";
import { WarningIcon } from "../svgs";
import { DynamicButton } from "../common";

const ConfirmModal = ({
  background,
  hideModal,
  title,
  description,
  handleOnConfirm,
}) => {
  return (
    <ModalHolder>
      <div
        style={{
          background: "#fff",
          position: "relative",
          padding: "30px",
          maxWidth: "480px",
          width: "90%",
          boxSizing: "border-box",
          textAlign: "center",
          borderRadius: "15px",
          fontFamily: "MTNRegular",
        }}
      >
        <div>
          <div>
            <WarningIcon width={52} fill={"#E31C79"} />
            <div
              style={{
                margin: "25px 0 15px 0",
                fontSize: "24px",
                fontFamily: "MTNMedium",
              }}
            >
              {title || "Confirm"}
            </div>
            <div
              style={{
                margin: "0 0 25px 0",
                fontSize: "14px",
                color: "#7F7F7F",
                lineHeight: "150%",
                fontFamily: "MTNRegular",
              }}
            >
              {description || "Are you sure of this action?"}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "130px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                  borderRadius: "40px",
                  border: "1px solid red",
                  borderColor: "#E31C79",
                  color: "#E31C79",
                  height: 43,
                  marginRight: 10,
                }}
                onClick={() => {
                  hideModal();
                }}
              >
                {"Cancel"}
              </div>
              <DynamicButton
                label={"Remove quote"}
                color={"#E31C79"}
                onClick={() => {
                  handleOnConfirm();
                }}
                width='130px'
                style={{ margin: "5px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </ModalHolder>
  );
};

const ModalHolder = ({ children }) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "20px",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {children}
      </div>
    </div>
  );
};

const Button = styled.button`
  border-radius: 20px;
  border: ${({ borderColor }) => `2px solid ${borderColor}`};
  background-color: ${({ bgColor }) => `${bgColor}`};
  color: ${({ textColor }) => `${textColor}`};
  padding: 5px 10px;
  width: 100px;
  box-sizing: border-box;
  font-size: 14px;
`;

export default ConfirmModal;
